import _ from 'lodash';

const resolveUserName = (usersById, userId) => usersById?.[userId]?.name || userId || '';

export const getSortedExceptions = (exceptions, subCategoryNameById, usersById) =>
  _.orderBy(exceptions, ['requestedDate'], ['desc']).map(exception => ({
    ...exception,
    subCategoryName: subCategoryNameById[exception.subCategoryId] || '',
    requestedByUserName: resolveUserName(usersById, exception.requestedByUserId),
    decidedByUserName: resolveUserName(usersById, exception.decisionedByUserId),
  }));

export const getSubCategoryNameById = subCategories =>
  Object.fromEntries((subCategories || []).map(item => [item.id, item.name]));
